import React from 'react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import Alert from './Alert';

interface NetworkStatusIndicatorProps {
  showOnlineStatus?: boolean;
  className?: string;
}

export const NetworkStatusIndicator: React.FC<NetworkStatusIndicatorProps> = ({
  showOnlineStatus = false,
  className = ''
}) => {
  const { isOnline, isSlowConnection, connectionType } = useNetworkStatus();

  if (isOnline && !isSlowConnection && !showOnlineStatus) {
    return null;
  }

  if (!isOnline) {
    return (
      <Alert variant="danger" className={`network-status-indicator ${className}`}>
        <div className="network-status-content">
          <span className="status-icon">⚠️</span>
          <div>
            <strong>No Internet Connection</strong>
            <p>You're currently offline. Some features may not work properly.</p>
          </div>
        </div>
      </Alert>
    );
  }

  if (isSlowConnection) {
    return (
      <Alert variant="warning" className={`network-status-indicator ${className}`}>
        <div className="network-status-content">
          <span className="status-icon">🐌</span>
          <div>
            <strong>Slow Connection Detected</strong>
            <p>
              Your connection appears to be slow ({connectionType}). 
              Some features may take longer to load.
            </p>
          </div>
        </div>
      </Alert>
    );
  }

  if (showOnlineStatus) {
    return (
      <Alert variant="success" className={`network-status-indicator ${className}`}>
        <div className="network-status-content">
          <span className="status-icon">✅</span>
          <div>
            <strong>Connected</strong>
            <p>Your internet connection is working normally.</p>
          </div>
        </div>
      </Alert>
    );
  }

  return null;
};